module.exports = __webpack_public_path__ + "static/media/ic_history.64de3847.svg";